import { doLogout } from "./authAction";
import {
  BASE_URL,
  DATA_USER_GET_ERROR,
  DATA_USER_GET_LOADING,
  DATA_USER_GET_SUCCESS,
} from "./constant";

const dataUserGetError = (bool) => {
  return {
    type: DATA_USER_GET_ERROR,
    dataUserGetError: bool,
  };
};

const dataUserGetLoading = (bool) => {
  return {
    type: DATA_USER_GET_LOADING,
    dataUserGetLoading: bool,
  };
};

const dataUserGetSuccess = (bool, dataUsers) => {
  return {
    type: DATA_USER_GET_SUCCESS,
    dataUserGetSuccess: bool,
    dataUsers,
  };
};

export function dataUsersAll(data) {
  return (dispatch) => {
    dispatch(dataUserGetSuccess(false, null));
    dispatch(dataUserGetError(false));
    dispatch(dataUserGetLoading(true));

    let config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    fetch(BASE_URL + "portal/users", config)
      .then((response) => {
        if (response.status === 401) {
          dispatch(doLogout());
        }

        if (!response.ok) {
          throw Error(response.statusText);
        }

        // dispatch(userGetLoading(false))
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        dispatch(dataUserGetLoading(false));
        dispatch(dataUserGetSuccess(true, data));
      })
      .catch((err) => {
        dispatch(dataUserGetError(true));
        dispatch(dataUserGetLoading(false));
      });
  };
}
